import { ReactForm } from "app/components/common/Form";
import { PageContentHeader } from "app/components/common/PageContentHeader";
import Translator from "app/components/common/Translator";
import { LoginUser } from "models/LoginUser";
import { StoreModel } from "models/StoreModel";
import { Translations } from "models/Translations";
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { LoginUserActions } from "redux/actions/LoginUserActions";

interface Props {
    store: StoreModel;
    loginUser: LoginUser;
    resetPassword: typeof LoginUserActions.resetPassword;
    translations: Translations;
}

class RegisterComp extends React.Component<Props> {
    ready() {
        return this.props.translations
    }

    render() {
        if (!this.ready()) {
            return (
                <div className="c-page__content">
                    <PageContentHeader text="Reset your password" />
                    <Translator text="Loading" />
                </div>
            )
        }
        let form = { email: '' };
        return (
            <div className="c-page__content">
                <PageContentHeader text="Reset your password" />
                <div className="c-card">
                    <ReactForm
                        loginUser={this.props.loginUser}
                        formObject={form}
                        store={this.props.store}
                        toolTips={[{ divId: "email", text: "Enter the Email you used to register, or which you have been invited with" }]}
                        anonymous
                        callback={this.props.resetPassword}
                    />
                </div>
            </div>
        )
    }
}

function mapStateToProps(state: StoreModel) {
    return {
        loginUser: state.loginUser,
        store: state,
        translations: state.translations
    };
}
function mapDispatchToProps(dispatch: Dispatch) {
    return {
        resetPassword: bindActionCreators(LoginUserActions.resetPassword, dispatch),
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RegisterComp);